import React from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import {Login} from "../pages/Login/Login.jsx";
import {Home} from "../pages/Home/Home.jsx";
import {ProtectedRoutes} from "./ProtectedRoutes.jsx";
import {Logout} from "../pages/Logout/Logout.jsx";
import {About} from "../pages/About/About.jsx";
import {ShipmentHistory} from "../pages/ShipmentHistory/ShipmentHistory.jsx";
import {NotFound} from "../pages/NotFound/NotFound.jsx";
import {RequestPasswordReset} from "../pages/RequestPasswordReset/RequestPasswordReset.jsx";
import TestDataGrid from "../pages/Showcase/subPages/TestDataGrid/TestDataGrid.jsx";
import {TestForm} from "../pages/Showcase/subPages/TestForm/TestForm.jsx";
import {TestDialogs} from "../pages/Showcase/subPages/TestDialogs/TestDialogs.jsx";
import {Showcase} from "../pages/Showcase/Showcase.jsx";

export const AppPath = {
    home: '/',
    apiRoot: '/api',
    login: '/login',
    logout: '/logout',
    requestPasswordReset: '/password-reset-request',
    activateAccount: '/activate-account',
    // ResetPassword: '/reset-password',
    about: '/about',
    showcase: "/showcase",
        testDataGrid: "/showcase/test-data-grid",
        testForm: "/showcase/test-form",
        testDialogs: "/showcase/test-dialogs",
    shipmentHistory: '/shipment-history',
    notFound: "/*",

    // sub routes

}


function AppRouter() {

    return (
        <BrowserRouter>
            <Routes>
                {/* Protected Routes */}
                <Route element={<ProtectedRoutes />}>
                    <Route path={AppPath.home} element={<Home />} />
                    <Route path={AppPath.testDataGrid} element={<TestDataGrid />} />
                    <Route path={AppPath.testForm} element={<TestForm />} />
                    <Route path={AppPath.testDialogs} element={<TestDialogs />} />
                    <Route path={AppPath.showcase} element={<Showcase />} />
                    <Route path={AppPath.about} element={<About />} />
                    <Route path={AppPath.shipmentHistory} element={<ShipmentHistory />} />
                </Route>

                {/* Unprotected Routes */}
                <Route path={AppPath.login} element={<Login />} />
                <Route path={AppPath.logout} element={<Logout />} />
                <Route path={AppPath.requestPasswordReset} element={<RequestPasswordReset />} />
                <Route path={AppPath.notFound} element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}
export default AppRouter;